<template>
  <div class="form_item">
    <div>
      <Label :required="required" :label="label" :name="save_to" />
      <masked-input
        type="tel"
        :name="validationLabel || label"
        :key="label"
        :required="required"
        :id="save_to"
        v-model="val"
        :autocomplete="autocomplete"
        :pipe="autoCorrectedDatePipe"
        :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
        :placeholder="placeholder"
        inputmode="tel"
        @blur.native="onBlur()"
        @change.native="onChange()"
        v-validate="rules"
      />
    </div>
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span
      class="error"
      v-show="error && errors.has(validationLabel || label)"
      v-html="
        forceErrorMessage || errors.collect(validationLabel || label).pop()
      "
    ></span>
  </div>
</template>

<script>
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import MaskedInput from "vue-text-mask";
import { validatorComponent } from "./validatorComponentMixin";
import { customBlurMixin } from "./customBlurMixin";

function createCustomDatePipe() {
  return function (conformedValue) {
    // Le conformedValue est la valeur actuelle du champ après que l'utilisateur a tapé
    const dateParts = conformedValue.split("/");

    // Assurez-vous que la longueur de chaque partie de la date est correcte
    const day = dateParts[0] ? dateParts[0].slice(0, 2) : "";
    const month = dateParts[1] ? dateParts[1].slice(0, 2) : "";
    const year = dateParts[2] ? dateParts[2].slice(0, 4) : "";

    // Validation flexible : pas de correction tant que l'utilisateur tape
    let isValid = true;

    if (day && (Number(day) < 1 || Number(day) > 31)) {
      isValid = false;
    }
    if (month && (Number(month) < 1 || Number(month) > 12)) {
      isValid = false;
    }
    if (year && year.length === 4 && Number(year) < 1900) {
      isValid = false;
    }

    // Retourner la valeur "conformed" sans appliquer de correction stricte
    return {
      value: `${day}${month ? "/" + month : ""}${year ? "/" + year : ""}`,
      indexesOfPipedChars: [],
      isValid: isValid,
    };
  };
}

export default {
  name: "DateInput",
  components: { MaskedInput },
  mixins: [validatorComponent, customBlurMixin],
  props: {
    save_to: String,
    min: String,
    max: String,
    validationLabel: String,
    forceErrorMessage: String,
    required: Boolean,
    isBirthBate: Boolean,
    dateMaxToday: Boolean,
    placeholder: {
      type: String,
      default: "jj/mm/aaaa",
    },
  },
  data: function () {
    return {
      createAutoCorrectedDatePipe: createAutoCorrectedDatePipe,
      autocomplete: this.isBirthBate ? "bday" : undefined,
    };
  },
  computed: {
    rules() {
      const a = {
        required: this.required,
        date_format: "dd/MM/yyyy",
      };
      var isIE = /*@cc_on!@*/ false || !!document.documentMode;
      if (!isIE) {
        const max = this.dateMaxToday
          ? new Date().toLocaleDateString("fr")
          : new Date(this.max).toLocaleDateString("fr");
        const min = new Date(this.min).toLocaleDateString("fr");
        if (
          this.min !== undefined &&
          (this.max !== undefined || this.dateMaxToday)
        )
          a.date_between = [min, max, true];
        else if (this.min !== undefined) a.after = [min, true];
        else if (this.max !== undefined || this.dateMaxToday)
          a.before = [max, true];
      }
      return a;
    },
  },
  methods: {
    autoCorrectedDatePipe: createCustomDatePipe(),

    async validateField() {
      let isValid = await this.$validator.validate(
        this.validationLabel || this.label,
      );

      // Check if the date is valid
      const [day, month, year] = this.val.split("/");
      if (Number(day) && Number(month) && Number(year) && year.length === 4) {
        const date = new Date(year, month - 1, day);
        const isValidDate =
          date.getDate() == day &&
          date.getMonth() == month - 1 &&
          date.getFullYear() == year;

        if (!isValidDate) {
          this.$validator.errors.add({
            field: this.validationLabel || this.label,
            msg: "La date n'est pas valide.",
          });

          isValid = false;
        }
      }

      this.error = !isValid;
      this.$forceUpdate(); // Force une mise à jour de Vue
    },

    onBlur() {
      this.validateField();
    },

    onChange() {
      this.validateField();
    },
  },
};
</script>
